import FancySelect from './FancySelect.vue';
export default FancySelect;
